'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDebugEnabled;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isDebugEnabled() {
  var query = (0, _get2.default)(global.window, 'location.search', '');
  var debugRegex = /debugMint=true/;
  return !!query.match(debugRegex);
}